import { Mail, Home, Search, Database, User, HelpCircle, LogOut, Circle, Crosshair, Star, Folder, Watch, Bell, List, Send, Volume2, Shield } from 'react-feather'

export const candidateNav = [
  
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: <Home size={20} />,
    navLink: '/tableau-de-bord'
  },
  {
    header: 'nav_job_offers'
  },
  {
    id: 'jobSearch',
    title: 'nav_search_job',
    icon: <Crosshair size={20} />,
    navLink: '/rechercher-un-emploi'
  },
  {
    id: 'mySearch',
    title: 'nav_my_researches',
    icon: <Search size={20} />,
    navLink: '/ma-recherche'
  },
  {
    id: 'favoris',
    title: 'nav_favorite',
    icon: <Star size={20} />,
    navLink: '/mes-favoris'
  },
  {
    header: 'nav_my_cand'
  },
  {
    id: 'jobs',
    title: 'nav_my_cand',
    icon: <Mail size={20} />,
    children: [
      {
        id: 'retention',
        title: 'nav_retention_cand',
        icon: <Circle size={20} />,
        navLink: '/candidatures-retenues'
      },
      {
        id: 'pending',
        title: 'nav_pending_cand',
        icon: <Circle size={20} />,
        navLink: '/candidatures-en-attente'
      },
      {
        id: 'refused',
        title: 'nav_refused_cand',
        icon: <Circle size={20} />,
        navLink: '/candidatures-refusees'
      }
    ]
  },
  {
    id: 'validMissions',
    title: 'valid_missions',
    icon: <Send size={20} />,
    navLink: '/missions-valides'
  },
  {
    id: 'myPropositions',
    title: 'nav_my_proposals',
    icon: <List size={20} />,
    navLink: '/mes-propositions'
  },
  {
    header: 'nav_my_account'
  },
  {
    id: 'myDatas',
    title: 'nav_my_data',
    icon: <Database size={20} />,
    navLink: '/mes-informations'
  },
  {
    id: 'myProfiles',
    title: 'nav_my_profiles',
    icon: <User size={20} />,
    navLink: '/profil'
  },
  {
    id: 'myDoc',
    title: 'nav_my_docs',
    icon: <Folder size={20} />,
    navLink: '/mes-documents'
  },
  {
    header: 'nav_management'
  },
  {
    id: 'time',
    title: 'nav_hours',
    icon: <Watch size={20} />,
    navLink: '/fiches-horaires'
  },
  {
    id: 'notification',
    title: 'my_notifications',
    icon: <Bell size={20} />,
    navLink: '/notifications'
  },
  // {
  //   id: 'agencyDocs',
  //   title: 'agency_docs',
  //   icon: <Folder size={20} />,
  //   navLink: '/agency-docs'
  // },
  {
    header: 'nav_parameters'
  },
  {
    id: 'settings',
    title: 'security',
    icon: <Shield size={20} />,
    navLink: '/parametres'
  },
  {
    id: 'communicate',
    title: 'nav_communicate',
    icon: <Volume2 size={20} />,
    navLink: '/communication'
  },
  {
    id: 'support',
    title: 'nav_support',
    icon: <HelpCircle size={20} />,
    navLink: '/support'
  },
  {
    id: 'logOut',
    title: 'nav_disconnection',
    icon: <LogOut size={20} />,
    navLink: '#',
  }
]
